import { FloatingDelayGroup } from '@floating-ui/react';
import React from 'react';
export var defaultDelay = { open: 500, close: 150 };
export var TooltipDelayGroup = function (_a) {
    var children = _a.children;
    return (React.createElement(FloatingDelayGroup, { delay: defaultDelay }, children));
};
//# sourceMappingURL=TooltipDelayGroup.js.map